// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__2YzHz","btnRed":"styles_btnRed__EIceN","content":"styles_content__3WUuX"};